import client from '../http_client';
import { UsageBalanceResponse, UsageTransactionsResponse } from './types';

export async function getUsageBalance(): Promise<UsageBalanceResponse> {
  const response = await client.get<UsageBalanceResponse>('/v1/usage/balance');
  return response.data;
}

export async function getUsageTransactions(params?: {
  limit?: number;
  offset?: number;
  since?: string;
  before?: string;
}): Promise<UsageTransactionsResponse> {
  const response = await client.get<UsageTransactionsResponse>('/v1/usage/transactions', {
    params,
  });
  return response.data;
}
